import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("fieldops_user");
    const token = localStorage.getItem("fieldops_token");
    if (!token) {
      setReady(true);
      setUser(false);
      return;
    }
    if (stored) {
      try { setUser(JSON.parse(stored)); } catch (_) { /* ignore parse error */ }
    }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("fieldops_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("fieldops_token");
        localStorage.removeItem("fieldops_user");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("fieldops_token", data.access_token);
    localStorage.setItem("fieldops_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    localStorage.removeItem("fieldops_token");
    localStorage.removeItem("fieldops_user");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
